import * as util from "lib/util.js";
import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import PubSub from "pubsub-js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import "../store/httpError";
import "./kb-toc.js";
import "./kb-topic.js";
import "./kb-topic-breadcrumbs.js";
import "./kb-topic-prevnext.js";

/**
 * Renders helpset topic
 * @property itemToc - Table of contents for helpset
 */
class KbHelpset extends LitElement {
  constructor() {
    super();
  }

  static get properties() {
    return {
      locationExtId: { type: String },
      itemToc: { type: Object },
    };
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.addEventListener(
      "tocItemClicked",
      this._handleTocItemClicked.bind(this)
    );
    this.addEventListener(
      "topicLinkClicked",
      this._handleTocTopicLinkClicked.bind(this)
    );
    // this.addEventListener('crossLinkClicked', this._handleCrossLinkClicked.bind(this));
    this.addEventListener("scrollHelpsetBy", this._scrollHelpsetBy.bind(this));
    window.addEventListener("resize", this.handleResize.bind(this));

    if (this.state.item) {
      this.refreshData();
      storeInstance.dispatch("getParentPath", { extId: this.locationExtId });
    }

    if (this.searchitem) {
      storeInstance.dispatch("getHelpsetTOC", {
        externalId: this.searchitem,
        langCode: this.state.langCode,
      });
    }
    window.addEventListener("popstate", this.handleBackButtonClick.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("popstate", this.handleBackButtonClick);
  }

  _scrollHelpsetBy(e) {
    if (!this.rightside) {
      this.rightside = this.shadowRoot.querySelector("#rightside");
    }
    if (this.rightside && e.detail > 0) {
      this.rightside.scrollTop = e.detail;
    }
  }

  async getItemToc() {
    let searchParams = new URLSearchParams({
      helpsetExtId: this.state.item.item.externalId,
      langCode: this.state.langCode,
    });
    try {
      const response = await fetch(
        `/kb/jrest/getHelpsetTOC?${searchParams.toString()}`
      );
      if (!response.ok) {
        httpError(response);
        throw Error();
      }
      return response.json();
    } catch (e) {
      console.log(e);
    }
  }

  async refreshData() {
    this.itemToc = await this.getItemToc();
    this.kbrid = this.kbrid ? this.kbrid : this._recurseToHREF(this.itemToc[0]); //if no kbrid passed in, then find first in toc
    this.rootnode = { nodes: this.itemToc };
    this.selectedNode = undefined;
    this.testOmniRecurse(this.rootnode, null, this.kbrid);
    if (this.selectedNode) {
      this.selectedNode.fragment = this.frag;
      util.setOpened(this.selectedNode);
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: this.selectedNode,
      });
    } else {
      this.showNotFound();
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.showSearchView = false;
    if (window.location.pathname.indexOf("/kbsearch/") > 0) {
      this.showSearchView = true;
    }
    if (this.kbrid) {
      if (this.kbrid.includes("#")) {
        var aTmp = this.kbrid.split("#");
        this.kbrid = aTmp[0];
        this.frag = aTmp[1];
      }
    }
    // if (this.itemToc) {
    //   if (!this.rootnode) {
    //     this.kbrid = this.kbrid
    //       ? this.kbrid
    //       : this._recurseToHREF(this.itemToc[0]); //if no kbrid passed in, then find first in toc
    //     this.rootnode = { nodes: this.itemToc };
    //     this.selectedNode = undefined;
    //     this.testOmniRecurse(this.rootnode, null, this.kbrid);
    //     if (this.selectedNode) {
    //       this.selectedNode.fragment = this.frag;
    //       util.setOpened(this.selectedNode);
    //       storeInstance.dispatch("setState", {
    //         property: "selected_tocitem",
    //         value: this.selectedNode,
    //       });
    //     }
    //   }
    if (this.state.toc_open && window.innerWidth > 960) {
      this.leftSideWidthPerc = this.state.global_screen_specs.tocWidthPercent;
      this.rightSideWidthPerc =
        this.state.global_screen_specs.topicWidthPercent;
    } else if (this.state.toc_open) {
      this.leftSideWidthPerc = 100;
      this.rightSideWidthPerc = 0;
    } else {
      this.leftSideWidthPerc = 0;
      this.rightSideWidthPerc = 100;
    }
    //   this.myRender();
    // }
    this.myRender();
  }

  handleResize() {
    if (window.innerWidth < 960) {
      if (this.state.toc_open) {
        storeInstance.dispatch("setState", {
          property: "toc_open",
          value: false,
        });
      }
    } else {
      storeInstance.dispatch("setState", { property: "toc_open", value: true });
    }
  }

  testOmniRecurse(node, parent, selectedKbrid) {
    node.open = false; //handy place to set this default status
    node.selected = false;
    if (parent) {
      node.parent = parent;
    }
    if (selectedKbrid) {
      if (node.href == selectedKbrid) {
        node.selected = true;
        this.selectedNode = node;
      }
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this.testOmniRecurse(node.nodes[i], node, selectedKbrid);
      }
    } else {
      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          this.testOmniRecurse(node.children[i], node, selectedKbrid);
        }
      }
    }
  }

  _getKbridObj(inVal) {
    var tmpVal = inVal;
    var aTemp = inVal.split("_");
    if (aTemp.length > 4) {
      tmpVal =
        aTemp[0] +
        "_" +
        aTemp[1] +
        "_" +
        aTemp[2] +
        "_" +
        aTemp[3] +
        "#" +
        aTemp[4].substring(1);
      for (var i = 5; i < aTemp.length; i++) {
        tmpVal = tmpVal + "_" + aTemp[i];
      }
    }

    aTemp = tmpVal.split("#");
    var retval = {};
    retval.kbrid = inVal;
    retval.kbridRaw = aTemp[0];
    retval.fragment = aTemp[1];
    return retval;
  }

  _setSelected(node, href) {
    node.selected = false;
    if (node.href == href) {
      node.selected = true;
      node.fragment = null;
      this.selectedNode = node;
      util.setOpened(this.selectedNode);
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: node,
      });
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this._setSelected(node.nodes[i], href);
      }
    }
  }

  _recurseToHREF(node) {
    if (node.href) {
      return node.href;
    } else {
      for (var i = 0; i < node.nodes.length; i++) {
        let foundHref = this._recurseToHREF(node.nodes[i]);
        if (foundHref) return foundHref;
      }
    }
    return undefined;
  }

  _tocItemWithHREF(node) {
    if (this._isCurrentItem(node.href)) {
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.locationExtId +
          "/" +
          node.href
      );
      this.kbrid = node.href;
      this.kbridObj = this._getKbridObj(this.kbrid);
      this._setSelected(this.rootnode, this.kbridObj.kbridRaw);
      if (this.selectedNode && this.kbridObj.fragment) {
        this.selectedNode.fragment = this.kbridObj.fragment;
      }
      if (!this.rightside) {
        this.rightside = this.shadowRoot.querySelector("#rightside");
      }
      this.rightside.scrollTop = 0;
    } else {
      /*hmmm might need to deduce ITEM TYPE from the node.href */
      Router.go(
        "/kb/" + this.state.langCode + "/" + this.locationExtId + node.href
      );
    }
  }

  async handleBackButtonClick() {
    if (window.location.href.includes("kbsearch")) {
      location.reload(); // a hack to re-load the product tree when going back from within helpset search result
    }
  }

  _handleTocItemClicked(e) {
    var node = e.detail;
    this.searchitem = null;
    if (node.href) {
      this._tocItemWithHREF(node);
    }
  }

  _handleTocTopicLinkClicked(e) {
    if (this._isCurrentItem(e.detail)) {
      history.pushState(
        null,
        null,
        "/kb/" + this.state.langCode + "/" + this.locationExtId + e.detail
      );
      this.kbrid = e.detail;
      this.kbridObj = this._getKbridObj(this.kbrid);
      this._setSelected(this.rootnode, this.kbridObj.kbridRaw);
      if (this.selectedNode && this.kbridObj.fragment) {
        this.selectedNode.fragment = this.kbridObj.fragment;
      }
      storeInstance.dispatch("touch");
    }
  }

  _isCurrentItem(href) {
    var aTmp = href.split("~");
    if (aTmp.length > 0) {
      if (aTmp[2] == this.state.item.item.externalId) {
        return true;
      }
    }
    return false;
  }

  handleToggleButtonClick() {
    storeInstance.dispatch("setState", {
      property: "toc_open",
      value: !this.state.toc_open,
    });
  }

  myRender() {
    render(this.helpsetTemplate(), this.shadowRoot);
    if (!this.helpsetcontainer) {
      this.helpsetcontainer =
        this.shadowRoot.querySelector("#helpsetcontainer");
      this.helpsetcontainer.addEventListener(
        "splitter-dragend",
        this.updateScreenWidthSpecs.bind(this)
      );
    } else {
      if (!this.state.toc_open) {
        var leftPx = 0;
        var rightPx = this.state.global_screen_specs.viewportWidth;
      } else {
        var leftPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.leftSideWidthPerc
        );
        var rightPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.rightSideWidthPerc
        );
      }
      this.helpsetcontainer.children[0].style.flex = "1 1 " + leftPx + "px";
      this.helpsetcontainer.children[1].style.flex = "1 1 " + rightPx + "px";
    }
  }

  updateScreenWidthSpecs(e) {
    storeInstance.dispatch("setHelpsetLayoutWidths", {
      left: e.currentTarget.children[0].offsetWidth,
      right: e.currentTarget.children[1].offsetWidth,
    });
    storeInstance.dispatch("setState", {
      property: "toc_open",
      value: e.currentTarget.children[0].offsetWidth > 0,
    });
  }

  showNotFound() {
    PubSub.publish("message.topic", this.kbrid);
  }

  helpsetTemplate() {
    return html`
      <style>
        #leftside {
          height: ${this.state.global_screen_specs.workspaceHeight}px;
          overflow: auto;
          padding: ${this.state.toc_open ? "0.5rem 0rem 0 0.5rem" : "0"};
          background-color: var(--background-color);
          width: ${this.leftSideWidthPerc}%;
        }
        #rightside {
          height: calc(100vh - var(--kb-header-height, 6rem));
          background: var(--kb-document-background);
          overflow: auto;
          width: ${this.rightSideWidthPerc}%;
        }
        #pagewrapper {
          /* max-width:1024px;
                            padding: var(--block-padding); */
          width: 91%;
          margin: 0 auto;
          padding: 1rem 0;
        }
        #topicwrapper {
          background-color: var(--kb-surface-color);
          border: 1px solid black;
          padding: 1.5rem 3rem;
          margin-top: var(--block-padding);
          border: var(--kb-surface-border);
          border-radius: var(--kb-border-radius);
        }

        #search {
          margin: 0.5rem 1.5rem 0.5rem 1.5rem;
        }
        #searchbtn {
          padding-left: 0.5rem;
          cursor: pointer;
        }
        #searchbox {
          --_ui5_input_width: 10rem;
        }

        .toc-toggle {
          position: absolute;
          bottom: 1rem;
          padding: 0.5rem;
          border-radius: 100%;
          border: none;
          cursor: pointer;
          right: 1rem;
          color: var(--kb-text-color-light);
          background: var(--kb-primary-color-400);
        }

        @media only screen and (min-width: 1400px) {
          #pagewrapper {
            width: 83%;
          }
        }
      </style>
      <div id="helpsetcontainer" style="display: flex;">
        <div id="leftside">
          <kb-toc .rootnode="${this.rootnode}" .kbrid="${this.kbrid}"></kb-toc>
        </div>
        <div id="rightside">
          <div id="pagewrapper">${this._rightSdideTemplate()}</div>
          <button
            @click=${this.handleToggleButtonClick.bind(this)}
            class="toc-toggle"
          >
            <iron-icon icon="vaadin:list-ul"></iron-icon>
          </button>
        </div>
      </div>
      <!-- <vaadin-split-layout id="helpsetcontainer">
                <div id='leftside'>
                    <kb-toc .rootnode="${this.rootnode}" .kbrid="${this
        .kbrid}"></kb-toc>
                </div>
                <div id='rightside'>
                    <div id='pagewrapper'>
                        ${this._rightSdideTemplate()}
                       
                    </div>        
                </div>
            </vaadin-split-layout> -->
    `;
  }

  /*
        <div id='search'>
            <iron-icon id="" icon="vaadin:close-small" @click="${this._clearSearch.bind(this)}"></iron-icon>
            <ui5-input id='searchbox' @keyup="${this.checkEnterKey.bind(this)}" placeholder="${this.string["_helpsetsearch"]}" value="${this._getSearchTerm()}"></ui5-input>
            <iron-icon id="searchbtn" icon="vaadin:search" @click="${this._search.bind(this)}"></iron-icon>
        </div>
        */

  _clearSearch() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    if (searchbox.value) {
      if (window.location.pathname.toLowerCase().includes("/kbsearch/")) {
        var aTmp = window.location.pathname.split("/");
        var tmpUrl = "/kb/" + aTmp[2] + "/" + aTmp[5];
        history.pushState(null, null, tmpUrl);
      }
      searchbox.value = "";
    }
    storeInstance.dispatch("setState", {
      property: "search_term",
      value: null,
    });
  }

  _getSearchTerm() {
    var retval = "";
    if (this.state.search_term) {
      if (this.state.search_term.item != "ROOT") {
        retval = this.state.search_term.searchterm;
      }
    }
    return retval;
  }

  _rightSdideTemplate() {
    if (this.showSearchView) {
      return html`<kb-searchview id="topic"></kb-searchview>`;
    } else {
      return html` <!-- <kb-topic-breadcrumbs .node="${this
          .selectedNode}"></kb-topic-breadcrumbs> -->
        <kb-topic-prevnext .node="${this.selectedNode}"></kb-topic-prevnext>
        <div id="topicwrapper">
          <kb-topic
            id="${this.selectedNode?.href}"
            .locationExtId=${this.locationExtId}
            .node="${this.selectedNode}"
          ></kb-topic>
        </div>`;
    }
  }
  checkEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this._search();
    }
  }
  _search() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    history.pushState(
      null,
      null,
      "/kb/" +
        this.state.langCode +
        "/kbsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
    Router.go(
      "/kb/" +
        this.state.langCode +
        "/kbsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
    storeInstance.dispatch("touch");
  }
}

customElements.define("kb-helpset", KbHelpset);
